import { render, staticRenderFns } from "./MonthlyTaxExport.vue?vue&type=template&id=13af2902&scoped=true"
import script from "./MonthlyTaxExport.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af2902",
  null
  
)

export default component.exports